import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function GlassSelect({ value, onChange, options, testId, className = "" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}
        className={`h-10 bg-slate-900/60 border-cyan-500/20 text-slate-200 text-sm capitalize rounded-lg focus:ring-0 focus:ring-offset-0 focus:border-cyan-400 data-[state=open]:border-cyan-400 ${className}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#0A0F1D]/95 backdrop-blur-xl border-cyan-500/20 text-slate-200">
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${testId}-option-${o.value}`}
            className="capitalize text-sm focus:bg-cyan-500/15 focus:text-cyan-200 data-[state=checked]:text-cyan-300">
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
